import { http } from "../http/Http";
import { CustomPickList, ServiceResponse, GetByFiltersArguments, CustomPickListValues } from "../models";

export class CustomPickListService {

    getCustomPickListsByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<CustomPickList[]>> => {
        const { data } = await http.post<ServiceResponse<CustomPickList[]>>("CustomPickList/GetByFilters", apiQueryFilter);
        return data;
    };

    getCustomPickList = async (id: number): Promise<CustomPickList> => {
        const { data } = await http.get<CustomPickList>(("CustomPickList/GetById/" + id.toString()));
        return data;
    };

    addCustomPickList = async (taskType: CustomPickList): Promise<CustomPickList> => {
        const { data } = await http.post<CustomPickList>("CustomPickList/Post", taskType);
        return data;
    };

    updateCustomPickList = async (taskType: CustomPickList): Promise<CustomPickList> => {
        const { data } = await http.put<CustomPickList>("CustomPickList/Put", taskType);
        return data;
    };

    getCustomPickListsValueByExternalId = async (id: string): Promise<CustomPickListValues> => {
        const { data } = await http.get<CustomPickListValues>(("CustomPickList/GetPickListValueByExternalId/" + id));
        return data;
    };

}